module.exports = __webpack_public_path__ + "img/khm.5a13865d.svg";